<template>
	<div class="dealer-home">
		<div class="dealer__info">
			<div class="container">
				<div class="dealer__inner">
					<div class="dealer__logo mx-auto shrink-0 hidden md:block">
						<img :src="location?.dealer?.logo?.thumb600" alt="dealer logo">
					</div>
					<div class="dealer__text">
						<h2 class="mb-2 uppercase">{{ location?.dealer?.name }}</h2>
						<h3 class="mb-2">{{ location?.city }}, {{ location?.state }}</h3>
						<p v-html="location?.dealer?.description"></p>
					</div>
				</div>
			</div>
		</div>
		<div class="inventory__section">
			<div class="container">
				<div class="inventory__title"><h1>INVENTORY</h1></div>
				<div class="inventory__filters">
					
				</div>
				<div class="inventory__grid grid-cols-1 md:grid-cols-3">
					<boat-card v-for="(boat, index) in boats" v-model="boats[index]" :key="'boat-' + index" @showroom="visiting = $event"></boat-card>
					<dealer-card></dealer-card>
				</div>
			</div>
		</div>
		<showroom-modal v-model="visiting" :boat="visiting"></showroom-modal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				visiting: null,
				page: 1
			};
		},
		computed: {
			boats() {
				return (this.$store.state.data || []);
			},
			location() {
				return this.$store.state.location;
			}
		},
		watch: {
			async filter() {
				await this.load();
			},
			async page() {
				await this.load();
			}
		},
		methods: {
			async load() {
				this.$store.state.loading++;
				try {
					this.$store.state.data = await this.$get('/json/boats', {filter: this.filter, page: this.page});
					this.$setSeo({
						title: 'Inventory | ' + this.location?.dealer?.name,
						description: this.location?.dealer?.short_description,
						keywords: 'nauticstar, boats, dealer, inventory',
						image: this.location?.dealer?.logo?.full
					});
				} catch(e) {}
				this.$store.state.loading--;
			}
		},
		async serverPrefetch() {
			await this.load();
			this.$store.state.serverFetched = true;
		},
		async mounted() {
			if(this.$store.state.serverFetched) {
				this.$store.state.serverFetched = false;
				return;
			}
			await this.load();
		}
	}
</script>